<template>
  <div v-if="isVisible" class="hilo-modal-overlay">
    <div class="hilo-modal">
      <header v-if="showHeader" class="hilo-modal-header">
        <slot name="header">
          <h3>{{ title }}</h3>
        </slot>
        <button class="hilo-modal-close" @click="closeModal">
          <i class="fas fa-times"></i>
        </button>
      </header>
      <div class="hilo-modal-body">
        <slot></slot>
      </div>
      <div class="hilo-modal-actions">
        <slot name="actions"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">

.hilo-modal-actions {
    position: absolute;
    width: 100%;
    bottom: 0;
    z-index: 2;
    left: 0;
    padding: 30px;
    background: #fff;
    display: flex;
    gap: 20px;

    button {
        flex: 1;
    }
}
.hilo-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.hilo-modal-overlay.bottom-right-overlay {
  pointer-events: none;
  background-color: transparent;
}

.hilo-modal-overlay.image-viewer-overlay {
  pointer-events: auto;
  z-index: 1002;
}

.hilo-modal {
  background-color: #fff;
  border-radius: 8px;
  width: 90%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: relative;

  @media (min-width: 768px) {
    width: 700px;
  }
}

.hilo-modal.bottom-right {
  position: fixed;
  bottom: 50px;
  right: 50px;
  width: 600px;
  max-width: 600px;
  z-index: 1001;
  pointer-events: auto;
}

.hilo-modal.image-viewer {
  width: 50%;
  height: 90%;
  max-width: 1200px;
  max-height: 90%;
  z-index: 1003;
}

.hilo-modal-header {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: 1px solid #f4f4f4;
  position: relative;
  padding-top: 30px;
  padding-bottom: 20px;
  position: relative;

  h3 {
    color: #404040;
    text-overflow: ellipsis;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin: 0;
  }
}

.hilo-modal-close {
  position: absolute;
  top: 35px;
  right: 51px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  padding: 0;
}

.hilo-modal-close i {
  font-size: 20px;
  color: #333;
  z-index: 1001;
}

.hilo-modal-body {
  padding: 30px 30px 120px 30px;
  max-height: 400px;
  overflow-y: auto;
  display: grid;
  gap: 20px;
}

.hilo-modal.image-viewer .hilo-modal-body {
  max-height: 80vh;
}

.hilo-modal-footer {
  display: flex;
  justify-content: center;
  padding: 16px;
  border-top: 1px solid #f4f4f4;
  gap: 10px;
}
</style>
